import { Typography, styled } from '@mui/material';

const StyledMonthlySessionEventText = styled(Typography)(({ theme }) => ({
  // En vista mes la sesión es texto sobre la celda del calendario (mode-aware): usar
  // text.primary para que sea legible en claro (oscuro) y en oscuro (blanco), en lugar
  // de heredar el blanco por defecto de FullCalendar (invisible sobre celda clara).
  color: theme.palette.text.primary,
  marginLeft: theme.spacing(1),
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap'
}));

export default StyledMonthlySessionEventText;
